import { SchedulingJobControllerApi } from '../api/generated';
import type { SchedulingJobResponse, SchedulingJobWeekStatusResponse } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';

// Queues a new scheduling job for a single week. The backend runs the solver
// asynchronously, so the returned job only reflects the state at queue time.
// Rejects with 409 when the week has already started and its plan is frozen.
export async function triggerWeekCalculation(
  locationId: string,
  scenarioId: string,
  weekNumber: number
): Promise<SchedulingJobResponse> {
  const api = new SchedulingJobControllerApi(createApiConfiguration());
  const response = await api.triggerCalculation({ locationId, scenarioId, weekNumber });
  return response.data;
}

// Every week's calculation status for one scenario, in one call. Sparse: weeks that have never been
// calculated are absent rather than returned with an "empty" status.
export async function fetchWeekCalculationStatuses(
  locationId: string,
  scenarioId: string
): Promise<SchedulingJobWeekStatusResponse[]> {
  const api = new SchedulingJobControllerApi(createApiConfiguration());
  const response = await api.getWeekStatuses({ locationId, scenarioId });
  return response.data;
}
